export const chatSettingsHeader = {
	title: 'Chat Settings',
};
